import { render, staticRenderFns } from "./EpssScore.vue?vue&type=template&id=46b274e9&scoped=true"
import script from "./EpssScore.vue?vue&type=script&lang=js"
export * from "./EpssScore.vue?vue&type=script&lang=js"
import style0 from "./EpssScore.vue?vue&type=style&index=0&id=46b274e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b274e9",
  null
  
)

export default component.exports